export default "__VITE_ASSET__7215e0c0__"